import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Section, CountdownTimer, CTAButton } from './Shared';
export const Pricing = () => {
  return <Section id="pricing" className="bg-brand-surfaceLight/30 rounded-3xl my-12" data-id="element-242">
      <div className="text-center mb-10" data-id="element-243">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-rose mb-6" data-id="element-244">
          ⏰ PRECIO DE LANZAMIENTO
        </h2>
        <CountdownTimer data-id="element-245" />
        <p className="mt-4 text-red-500 font-medium" data-id="element-246">
          ⚠️ ESTE PRECIO CIERRA PRONTO
        </p>
        <p className="mt-1 text-brand-text/70 text-sm" data-id="element-247">
          Después sube $8.000 ARS. No vuelve.
        </p>
        <p className="mt-4 text-brand-rose/80 text-sm font-medium" data-id="element-248">
          🔴 Quedan pocos cupos al precio de lanzamiento
        </p>

        <div className="max-w-md mx-auto mt-2" data-id="element-249">
          <div className="w-full bg-white rounded-full h-2.5 border border-brand-pink/30 overflow-hidden shadow-inner" data-id="element-250">
            <div className="bg-brand-rose h-2.5 rounded-full" style={{
            width: '68%'
          }} data-id="element-251"></div>
          </div>
          <p className="text-xs text-brand-text/60 mt-2" data-id="element-252">68% tomados</p>
        </div>
      </div>

      <div className="max-w-xl mx-auto" data-id="element-253">
        <div className="glass-panel rounded-3xl p-8 md:p-10 flex flex-col border-brand-rose relative shadow-[0_10px_40px_rgba(212,115,140,0.15)] bg-white/80 text-center" data-id="element-254">
          <div className="mb-6" data-id="element-255">
            <h4 className="text-2xl font-serif font-bold mb-2 text-brand-text" data-id="element-256">
              KIT REFLEXO-PRO COMPLETO
            </h4>
            <p className="text-brand-rose/90 font-medium" data-id="element-257">
              Tomo Principal + Bonus 1 + Bonus 2 · 110 páginas
            </p>
          </div>

          <div className="mb-8" data-id="element-258">
            <div className="text-xl text-brand-text/50 line-through mb-1" data-id="element-259">
              $37.000 ARS
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-260">
              $19.990
            </div>
          </div>

          <div className="mt-auto" data-id="element-261">
            <CTAButton fullWidth className="text-lg py-5 animate-pulse-slow" href="https://www.lumenakasha.com/cart/46722804678845:1" data-id="element-262">
              🦶 → QUIERO MI KIT REFLEXO-PRO AHORA
            </CTAButton>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-6 mt-12 text-sm text-brand-muted flex-row items-start justify-center" data-id="element-263">
        <div className="flex items-center" data-id="element-264">
          <Lock className="w-4 h-4 mr-2" data-id="element-265" /> Pago 100% seguro
        </div>
        <div className="flex items-center" data-id="element-266">
          <Zap className="w-4 h-4 mr-2" data-id="element-267" /> Acceso en 5 minutos
        </div>
        <div className="flex items-center" data-id="element-268">
          <Shield className="w-4 h-4 mr-2" data-id="element-269" /> Garantía 7 días
        </div>
        <div className="flex items-center" data-id="element-270">
          <CreditCard className="w-4 h-4 mr-2" data-id="element-271" /> Mercado Pago | Tarjeta |
          Transferencia
        </div>
      </div>
    </Section>;
};